import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { ChordHistoryInteractMode } from "../../models/ChordHistoryOptions.model";
import OptionMenuToggle from "../theme_reuse/OptionMenuToggle";
import ChordInteractModeDropdown from "../music_controls/custom_buttons/ChordInteractModeDropdown";

interface Props {}
interface State {}

const TITLE = "When you click on a chord...";
const shortNames = [
  ChordHistoryInteractMode.SOUND,
  ChordHistoryInteractMode.EDIT,
  ChordHistoryInteractMode.DELETE,
  ChordHistoryInteractMode.CHOOSE,
];
const descriptions = [
  "You'll hear the chord sound.",
  "You'll see a menu to explore voicings, edit, and save the chord.",
  "You'll delete that chord.  You can also delete entire scales.",
  "You'll copy it to the instrumentation window",
];

function printShortName(x: ChordHistoryInteractMode): string {
  switch (x) {
    case ChordHistoryInteractMode.SOUND:
      return "Hear it";
    case ChordHistoryInteractMode.EDIT:
      return "Edit it";
    case ChordHistoryInteractMode.DELETE:
      return "Delete it";
    case ChordHistoryInteractMode.CHOOSE:
      return "Instrument it";
  }
}

export default class ChordInteractionModeToggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeMode = (interactMode: ChordHistoryInteractMode) => {
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { interactMode } });
  };

  render(): ReactNode {
    const interactMode = this.context.chordHistoryOptions.interactMode;
    return (
      <OptionMenuToggle
        title={TITLE}
        optionShortNames={shortNames}
        optionDescriptions={descriptions}
        selected={interactMode}
        printShortName={printShortName}
        onChange={this.changeMode}
        extraInfo={
          <p>
            Shortcut: hold shift and press C to switch modes, or click the <ChordInteractModeDropdown /> button.
          </p>
        }
      />
    );
  }
}

ChordInteractionModeToggle.contextType = AppContextType;
